import React from 'react';
import { DialogTitle, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => {
  return (
    <DialogTitle
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          fontSize: '24px',
          color: (theme) => theme.customColors?.themeNeutralPrimaryColor
        }}
      >
        {title}
      </Typography>
      <IconButton
        onClick={onClose}
        size="small"
        sx={{
          color: (theme) => theme.customColors?.themeNeutralSecondaryColor,
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

export default ModalHeader;
